import { render, staticRenderFns } from "./recuperar_contraseña.vue?vue&type=template&id=a0f2c12c"
import script from "./recuperar_contraseña.js?vue&type=script&lang=js&external"
export * from "./recuperar_contraseña.js?vue&type=script&lang=js&external"
import style0 from "./recuperar_contraseña.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports